import React from 'react';
import { useAtomValue } from 'jotai';
import { Box, Typography } from '@mui/material';
import { userBranchesAtom } from '../../../Atoms';
import ActivityTypeAvatar from '../../../Components/ActivityTypeAvatar';
import CaptionValue from '../../../Components/CaptionValue/CaptionValue';
import Chip from '../../../Components/Chip';
import capitalize from '../../../Helpers/StringsFormatting/capitalize';
import {
  addZero,
  createNewDate,
  culture,
  options,
} from '../../../Helpers/dates';
import { OUTCOME_COLORS, counterChip } from '../Utils/constants';

//what this send is: campaign, channel, branch, date, size and queue status
const DetailsHeader = function DetailsHeader({
  campaign = null,
  massive = null,
  filters = null,
  templateName = '',
}) {
  const userBranches = useAtomValue(userBranchesAtom);
  const scheduledOn = campaign?.scheduledOn;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '16px 32px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          flex: '1 1 260px',
          minWidth: 0,
        }}
      >
        <ActivityTypeAvatar activityType={filters?.IsSMS ? 'SMS' : 'EMAIL'} />
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h6" noWrap>
            {capitalize(campaign?.name)}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {capitalize(templateName)}
          </Typography>
        </Box>
      </Box>
      <CaptionValue
        caption="BRANCH"
        value={capitalize(
          userBranches?.find(({ id }) => id === filters?.Branches?.[0])
            ?.branchDescription
        )}
      />
      <CaptionValue
        caption="SCHEDULEDON"
        value={
          scheduledOn
            ? `${createNewDate(scheduledOn).toLocaleDateString(culture, options)} - ${addZero(createNewDate(scheduledOn))}`
            : null
        }
      />
      <CaptionValue
        caption="CUSTOMERS_NUMBER"
        value={counterChip(
          massive?.enqueuedCustomers,
          OUTCOME_COLORS.CUSTOMERS
        )}
      />
      <CaptionValue
        caption="STATUS"
        value={
          <Chip
            label={massive?.status ? 'QUEUED' : 'QUEUING'}
            color={
              massive?.status ? OUTCOME_COLORS.POSITIVE : OUTCOME_COLORS.WARNING
            }
            width="fit-content"
          />
        }
      />
    </Box>
  );
};

export default DetailsHeader;
